import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let Warmup = class Warmup extends Vue {
    async created() {
        window.location.href = 'https://m.ivydad.com/center';
    }
};
Warmup = tslib_1.__decorate([
    Component({})
], Warmup);
export default Warmup;
